import React from "react";
import { useSelector } from "react-redux";
import { ReduxControls } from "rhombus-react";
import { getFormValues } from "redux-form";
import { CREATIVE_ASSET_TYPES } from "utils/constants";

import "./DynamicCreativeToggle.css";

const UNAVAILABLE_TEXT = "Dynamic Versions unavailable for this format";

export default function DynamicCreativeToggle(props){
	const { disabled, unavailable = false, input, meta } = props;
	const [adType] = input?.name?.split(".") || [];
	const { numOfVersions, creativeId, assetType } = useSelector(state => ({
		numOfVersions: state.creativeDetails?.numberOfVersions,
		creativeId: state.creativeDetails?.id,
		assetType: getFormValues(meta?.form)(state)?.[adType]?.assetType,
	}));
	const isExistingAECreative = !!creativeId && assetType === CREATIVE_ASSET_TYPES.AFTER_EFFECTS;
	// If there are any versions other than default, then disable the DynamicCreativeToggle
	const disableToggle = numOfVersions > 1 || disabled || isExistingAECreative;
	return (
		<div className="e-form__control-wrapper dynamic-creative-toggle">
			{unavailable && <span className="unavailable-notification">{UNAVAILABLE_TEXT}</span>}
			{!unavailable && <ReduxControls.Checkbox {...props} disabled={disableToggle} />}
		</div>
	);
}

DynamicCreativeToggle.displayName = "DynamicCreativeToggle";

/*
	This is just a field config object that you can drop into social form field lists, and it should just work.

	You can also just spread it into a redux-form Field component like:
	```
		<Field {...isDynamic} />
	```
*/
export const isDynamic = {
	name: "isDynamic",
	label: "Enable Dynamic Versions",
	className: "custom-checkbox",
	component: DynamicCreativeToggle,
	useValue: true,
};
